export default __webpack_public_path__ + "static/media/shrink.ffd78f92.svg";